/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Not_IncludedInputs */

const en_why_listening_compare_not_included = /** @type {(inputs: Why_Listening_Compare_Not_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not included`)
};

const es_why_listening_compare_not_included = /** @type {(inputs: Why_Listening_Compare_Not_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No incluido`)
};

/**
* | output |
* | --- |
* | "Not included" |
*
* @param {Why_Listening_Compare_Not_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_not_included = /** @type {((inputs?: Why_Listening_Compare_Not_IncludedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Not_IncludedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_not_included(inputs)
	return en_why_listening_compare_not_included(inputs)
});